import React from 'react';
import PropTypes from 'prop-types';
import { StyledTooltipAdvanced } from './style';

const TooltipAdvanced = props => (
  <StyledTooltipAdvanced className={props.className} position={props.position}>
    {props.children}
  </StyledTooltipAdvanced>
);

TooltipAdvanced.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  position: PropTypes.oneOf(['top', 'bottom', 'right', 'left'])
};

TooltipAdvanced.defaultProps = {
  position: 'top'
};

export default TooltipAdvanced;
